import React from "react";
import Player from "./Player";
import { ProjectProps } from "../types";

const Project = ({
  title,
  lead,
  author,
  vimeo_id: vimeoID,
  project_url: projectURL,
}: ProjectProps) => (
  <div className="tile project container">
    <Player url={`https://vimeo.com/${vimeoID}`} />
    <div className="project__content">
      <div className="row">
        <div className="column column--11">
          <div className="project__title">
            <h2>
              {title}
              <br />
              by {author}
            </h2>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="column column--6">
          <div className="project__lead">
            <p dangerouslySetInnerHTML={{ __html: lead }}></p>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="column column--12">
          <a target="_top" className="project__link" href={projectURL}>
            View Project
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default Project;
